<template>
  <div>
    <b-modal
      id="modal_news"
      ref="modal_news"
      modal-class="modal_news fade"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-md"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      footer-class="modal-footer position-relative justify-content-center border-top-0"
      content-class=""
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
    >
      <template v-slot:modal-header>
        <!-- <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="hideModal">
          <img src="@/assets/img/icon_close.png" width="20">
        </button> -->
        <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="hideModal">
          <i class="icon-clear" />
        </button>
      </template>
      <div class="news_wrap overflow-auto">
        <ul class="news_inner d-grid mb-0">
          <li>
            <div class="news_info d-grid">
              <img :src="$store.getters.permissionInfo.pop_announcement_image">
            </div>
          </li>
        </ul>
      </div>
      <template v-slot:modal-footer>
        <div class="news_btn d-grid justify-content-around" />
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      not_show_again: false
    }
  },
  methods: {
    submit() {
      if (this.not_show_again) {
        this.$store.commit('SET_READ_ANNOUNCEMENT', true)
      }
      this.hideModal()
    },
    hideModal() {
      this.$store.commit('SET_READ_ANNOUNCEMENT', true)
      this.$bvModal.hide('modal_news')
    }
  }
}
</script>

<style>
/*
@media only screen and (min-width: 1920px) {
  #modal_announcement .modal-dialog,
  #modal_announcement .modal-content {
      height: 704px;
  }
  #modal_announcement .modal-body {
      max-height: calc(100% - 78px);
      overflow-y: scroll;
  }
  #modal_announcement .modal-dialog {
    max-width: 1048px;
    max-height: 704px
  }
  #modal_announcement .modal-content .modal-header>h4 {
    font-size: 26px;
  }
  #modal_announcement .modal-content .modal-header {
    padding: 23px;
  }
  #modal_announcement .icon-clear:before {
    font-size: 40px;
  }
  #modal_announcement .text-content {
    font-size: 20px;
    line-height: 30px;
  }
  #modal_announcement .no_show_lab {
    font-size: 14px;
  }
  #modal_announcement .news_btn {
    width: 130px;
    height: 40px;
  }
  #modal_announcement .modal_news .btn_ok {
    font-size: 16px;
    width: 130px;
    height: 40px;
  }
}
@media only screen and (min-width: 933px) and (max-width: 1919px) {
  #modal_announcement .modal-dialog,
  #modal_announcement .modal-content {
      height: 627px;
  }
  #modal_announcement .modal-body {
      max-height: calc(100% - 70px);
      overflow-y: scroll;
  }
  #modal_announcement .modal-dialog {
    max-width: 933px;
  }
  #modal_announcement .modal-content .modal-header>h4 {
    font-size: 22px;
  }
  #modal_announcement .modal-content .modal-header {
    padding: 19px;
  }
  #modal_announcement .icon-clear:before {
    font-size: 34px;
  }
  #modal_announcement .text-content {
    font-size: 16px;
    line-height: 30px;
  }
  #modal_announcement .no_show_lab {
    font-size: 12px;
  }
  #modal_announcement .news_btn {
    width: 116px;
    height: 36px;
  }
  #modal_announcement .modal_news .btn_ok {
    font-size: 14px;
    width: 116px;
    height: 36px;
  }
}

@media only screen and (max-width: 1440px) {
  #modal_announcement .modal-dialog,
  #modal_announcement .modal-content {
      height: auto;
  }
  #modal_announcement .modal-body {
      max-height: calc(100% - 70px);
      overflow-y: scroll;
  }
}

@media only screen and (max-width: 934px) {
  #modal_announcement .content-img {
    display: none;
  }
}
#modal_announcement .modal-body {
  padding-top: 20px;
}
*/
</style>
